// eslint-disable-next-line
import styles from './aboutSection.css';
import aboutImage from './../../../pages/about.jpg';
import Section from './../section';

function AboutSection() {
    return (
        <Section title="O NAS">
            <div className="about-text">
                <h4>Drodzy Turyści! 🌞</h4>
                <p>Jesteśmy polsko-zanzibarskim zespołem z sercem do podróży i pasją do pokazywania piękna naszej wyspy. Nasza firma powstała z połączenia dwóch światów – doświadczenia lokalnych przewodników z Zanzibaru i polskiej gościnności. Dzięki temu możecie liczyć na pełne zrozumienie Waszych potrzeb i wycieczki prowadzone w języku polskim 🇵🇱🇹🇿</p> 

                <p>Organizujemy <b>lokalne wycieczki po Zanzibarze, jednodniowe safari w Tanzanii</b> oraz <b>transfery z i na lotnisko</b>. Posiadamy licencje i działamy legalnie jako przewodnicy i organizatorzy turystyki. Współpracujemy tylko ze sprawdzonymi kierowcami i przewodnikami, którzy nie tylko świetnie mówią po polsku, ale również kochają to, co robią.</p>

                <p>Podczas naszych wycieczek pokażemy Wam najpiękniejsze plaże, klimatyczne miasteczka, lokalne wioski i miejsca, które często umykają turystom. Opowiemy Wam o kulturze, codziennym życiu, tradycjach oraz fascynującej historii Zanzibaru. Zawsze odbierzemy Was bezpośrednio z hotelu i odwieziemy po zakończonej wycieczce, abyście mogli podróżować komfortowo i bez stresu.</p>

                <p>Zapraszamy Was serdecznie do wspólnej przygody! 🏝️</p>
                <p>Z nami poznacie Zanzibar od najlepszej strony.</p>
            </div>
            <img src={aboutImage} alt="O nas" className="about-image" />
        </Section>
    )
}

export default AboutSection;